// extracted by mini-css-extract-plugin
export default {"move_btn_wrap":"style_move_btn_wrap__AOggb","move_btn_box":"style_move_btn_box__SUXLh","move_btn":"style_move_btn__EKFgY"};